angular.module('impactx.invoice').controller('InvoiceSaveTemplateCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'templateNameInput',
    'headerLabel',
    'confirmLabel',
    'abortLabel',
    'requiredLabel',
    'existingEntryWarning',
    'receiverCompanyId',
    'dataGen',
    InvoiceSaveTemplateCtrl]);

function InvoiceSaveTemplateCtrl($scope, $mdDialog, themeFactory, templateNameInput, headerLabel, confirmLabel,
                                 abortLabel, requiredLabel, existingEntryWarning, receiverCompanyId, dataGen)
{
    var ctrl = this;
    $scope.required = true;
    $scope.templateNameInput = templateNameInput;
    $scope.templateNameInput.value = "";
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.headerLabel = headerLabel;
    $scope.existingEntryWarning = existingEntryWarning;
    $scope.theme = themeFactory.getTheme();
    $scope.nameExists = {value: false};
    dataGen.getData($scope, {receiverCompanyId: receiverCompanyId}, "/invoice/loadtemplates");
    $scope.$watch(function () {
            return $scope.templateNameInput.value;
        },
        function (newValue, oldValue)
        {
            if (newValue != oldValue)
            {
                $scope.nameExists.value = false;
                var i = 0;
                while (i < $scope.data.entries.length)
                {
                    if ($scope.data.entries[i].value == newValue)
                    {
                        $scope.nameExists.value = true;
                        break;
                    }
                    i++;
                }
            }
        });
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.confirm = function ()
    {
        $mdDialog.hide({
            templateName: $scope.templateNameInput.value
        });
    };
}